import type { Portfolio } from "@/types";

type AnyPortfolio = Pick<Portfolio, "portfolio_type"> & {
  portfolio_instructions?: {
    allocate_percentage?: number;
    limit_price?: string | null;
  } | null;
};

/**
 * Extract the minimum price from the company's currently configured SPOT_MIN_PRICE strategy.
 *
 * Forward-looking only: returns 0 when allocate_percentage is 0 even if the portfolio still
 * holds items with a configured limit_price. Do NOT use this to decide whether a specific
 * SPOT_MIN_PRICE item's limit applies — items in SPOT_MIN_PRICE always have an effective
 * limit.
 *
 * @throws {Error} When portfolio data is invalid
 */
export function getSpotMinimumPrice(
  portfolios: readonly AnyPortfolio[]
): number {
  const activeSpotMinPortfolio = portfolios.find(
    (portfolio) =>
      portfolio.portfolio_type === "SPOT_MIN_PRICE" &&
      (portfolio.portfolio_instructions?.allocate_percentage ?? 0) > 0
  );

  if (!activeSpotMinPortfolio?.portfolio_instructions?.limit_price) {
    return 0;
  }

  const price = Number(
    activeSpotMinPortfolio.portfolio_instructions.limit_price
  );
  return isNaN(price) ? 0 : price;
}
